// extracted by mini-css-extract-plugin
module.exports = {"videoCardSection":"video-card-section_videoCardSection__94WiR"};